import { Component, HostListener } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { ThemeService } from '../theme.service';
import { SessionStorageService } from 'src/app/core/services/session-storage.service';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterModule],
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  isMenuOpen = false;
  isDarkMode = false;
  userName = '';
  role = '';
  companyName = '';
  /** Controls modal visibility */
  showLogoutModal = false;

  /** Prevents double-clicks during the async logout */
  isLoggingOut = false;

  constructor(
    public theme: ThemeService,
    public sessionStorage: SessionStorageService,
    private router: Router
  ) { }

  ngOnInit() {
    this.userName = this.sessionStorage.getUser().fullName || '';
    this.companyName = this.sessionStorage.getCompanyData().companyName || '';
    this.role = this.sessionStorage.getUser().role || '';
  }

  toggleMenu() {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleTheme() {
    this.theme.toggleTheme();
  }

  // ── Logout modal lifecycle ─────────────────────────────────────────────────

  /** Called by the "Logout" menu item. Closes the dropdown and shows the modal. */
  openLogoutModal(event: Event): void {
    event.preventDefault();     // stop href="#" scroll-jump
    this.isMenuOpen = false;    // close dropdown first
    this.showLogoutModal = true;
  }

  /** Dismiss without logging out (Cancel button or backdrop click). */
  closeLogoutModal(): void {
    if (this.isLoggingOut) return; // don't allow dismissal mid-logout
    this.showLogoutModal = false;
  }

  /** Called by the "Yes, sign out" button. */
  confirmLogout(): void {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;

    // If logout is synchronous, navigate immediately.
    // Wrap in a tiny timeout so the spinner renders for at least one frame.
    setTimeout(() => {
      this.sessionStorage.logout();
      this.router.navigate(['/login']);
      this.isLoggingOut = false;
      this.showLogoutModal = false;
    }, 400);
  }

  // Close menu on outside click
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('app-header')) {
      this.isMenuOpen = false;
    }
  }

  navigate(path: string) {
  this.router.navigate([path]);
}

navigateToProfile(event: Event): void {
  event.preventDefault();
  this.isMenuOpen = false;
  this.navigate('/app/masters/companyDetails');
}

  // Close dropdown menu without navigation
  // for features not yet implemented.
  closeMenu(event: Event): void {
    event.preventDefault();
    this.isMenuOpen = false;
  }
}
